import React, {
  forwardRef,
} from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import TextField, {
  BaseTextFieldProps,
  StandardTextFieldProps,
} from '@mui/material/TextField';
import clsx from 'clsx';

type Props = BaseTextFieldProps & {
  value?: string;
  onChange?: (args: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'small' | 'medium';
  placeholder?: string;
  type?: React.InputHTMLAttributes<unknown>['type'];
  isWidthFull?: boolean;
  disabled?: boolean;
  error?: boolean;
  id?: string;
  name?: string;
  minLength?: number;
  maxLength?: number;
  autoComplete?: string;
  className?: string;
  InputProps?: StandardTextFieldProps['InputProps'];
};

const InputText = forwardRef<HTMLInputElement, Props>(({
  onChange,
  value,
  size = 'small',
  placeholder = '',
  type = 'text',
  isWidthFull,
  disabled = false,
  error = false,
  id,
  name = '',
  minLength,
  maxLength,
  autoComplete,
  className,
  sx,
  InputProps,
  ...props
}, ref) => {
  const customStyle: SxProps<Theme> = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      ...(error && {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'red !important',
          borderWidth: '1px !important',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'red !important',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'red !important',
          borderWidth: '2px !important',
        },
      }),
    },
    ...(isWidthFull && { width: '100%' }),
  };

  return (
    <TextField
      {...props}
      value={value ?? ''}
      placeholder={placeholder}
      sx={customStyle}
      size={size}
      type={type}
      onChange={onChange}
      disabled={disabled}
      error={error}
      id={id}
      name={name}
      inputRef={ref}
      InputProps={{
        inputProps: {
          maxLength,
          minLength,
        },
        ...InputProps,
      }}
      autoComplete={autoComplete}
      className={clsx('w-full', className)}
    />
  );
});

export default InputText;
